export class DateMonthRangeClass {
    public startMonth?: number;
    public startYear?: number;
    public endMonth?: number;
    public endYear?: number;
}